<template>
    <footer
        v-if="hasContacts || hasLinks || hasLogos"
        class="ct-footer">
        <div
            v-if="hasContacts"
            class="ct-footer__contacts">
            <div
                class="ct-footer__contacts__contact"
                v-for="contact, index in contacts"
                :key="index">
                <p>{{ contact.name }}</p>
                <a :href="contactHref(contact.value)">
                    {{ contact.value }}
                </a>
            </div>
        </div>
        <div
            v-if="hasLinks"
            class="ct-footer__links d-flex flex-column">
            <router-link
                class="ct-footer__link"
                v-for="link, index in links"
                :key="index"
                :to="routerLink(link)">
                {{ link.title }}
            </router-link>
        </div>
        <div
            v-if="hasLogos"
            class="ct-footer__logos">
            <template
                v-for="logo, index in logos">
                <template v-if="logo.route">
                    <router-link
                        :title="logo.name"
                        data-toggle="tooltip-city"
                        :key="index"
                        :to="{ name: logo.route }">
                        <img :alt="logo.name" class="" :src="assetsPathGlobalPlatform(`/${logo.path}`)">
                    </router-link>
                </template>
                <template v-else-if="logo.link">
                    <a
                        data-toggle="tooltip-city"
                        :title="logo.name"
                        :href="logo.link"
                        :key="index"
                        target="_blank">
                        <img :alt="logo.name" class="" :src="assetsPathGlobalPlatform(`/${logo.path}`)"></img>
                    </a>
                </template>
                <template v-else>
                    <img
                        class=""
                        data-toggle="tooltip-city"
                        :title="logo.name"
                        :key="index"
                        :alt="logo.name"
                        :src="assetsPathGlobalPlatform(`/${logo.path}`)" />
                </template>
            </template>
        </div>
    </footer>
</template>
<script>
import GlobalMixin from '@/app/shared/mixins/global';
import { isEmail } from '@config/utils';

export default {
    mixins: [
        GlobalMixin,
    ],
    data() {
        return {
            idPanel: 'footer',
            links: []
        }
    },
    mounted() {
        this.loadLinks();
    },
    computed: {
        footerConfig() {
            return this.$store.getters.footerConfig || {};
        },
        url() {
            return this.footerConfig.url ?? {};
        },
        contacts() {
            return this.footerConfig.contacts ?? [];
        },
        logos() {
            return this.footerConfig.images ?? [];
        },
        hasContacts() {
            return this.contacts.length > 0;
        },
        hasLinks() {
            return this.links.length > 0;
        },
        hasLogos() {
            return this.logos.length > 0;
        },
    },
    methods: {
        loadLinks: function() {
            let url = this.url.getLinks;
            if(url) {
                this.$http.get(url)
                .then(({data}) => {
                    this.links = data.data;
                });
            }
        },
        routerLink: function(link) {
            return this.getRouterLinkFromPage(link, {slug: link.slug}, 'redirect');
        },
        contactHref: function(val) {
            if(isEmail(val)) {
                return `mailto:${ val }`;
            }else{
                return `tel:${ val.replace(/\s/g, '') }`;
            }
        }
    }
}
</script>
